import SearchResultHeaders from './searchResultHeaders'

export default SearchResultHeaders
